/**
 * Created by YECHENGYOU on 2018/8/1.
 */
import Vue from 'vue'
import Vuex from 'vuex';
Vue.use(Vuex)
export default new Vuex.Store({
	state: {
		cartList: []
	},
	getters: {
	},
	mutations: {
		addCart (state, info) {
			const isAdded = state.cartList.find(item => item.id === info.id);
			if (isAdded) {
				isAdded.count ++;
			} else {
				state.cartList.push({
					id:info.id,
					count: 1,
					info:info
				})
			}
		},
		editCartCount (state, info) {
			const isDeled = state.cartList.find(item => item.id === info.id);
			if(isDeled.count > 0){
				isDeled.count --;
			}
			if(isDeled.count == 0){
				const index = state.cartList.findIndex(item => item.id === info.id);
				state.cartList.splice(index, 1);
			}
		},
		deleteCart (state, info) {
			const index = state.cartList.findIndex(item => item.id === info.id);
			state.cartList.splice(index, 1);
		},
		emptyCart (state) {
			state.cartList = [];
		}
	},
	actions: {
	}
});



// WEBPACK FOOTER //
// ./src/store/index.js